import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Enregistrement du service worker PWA.
// vite-plugin-pwa expose `virtual:pwa-register` pour brancher des hooks
// (mise a jour disponible, app prete offline). En mode `autoUpdate` + `skipWaiting`,
// le SW prend le controle automatiquement, donc on a juste besoin de l'appel
// d'enregistrement initial. L'import est asynchrone pour ne pas bloquer le bundle
// principal si le module est absent (dev sans PWA, environnement de test, etc.).
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  import('virtual:pwa-register')
    .then(({ registerSW }) => {
      registerSW({ immediate: true });
    })
    .catch(() => {
      // Pas de PWA en dev (devOptions.enabled = false) -> on ignore silencieusement.
    });
}
